import { render, staticRenderFns } from "./AddressesTab.vue?vue&type=template&id=9ffaf7dc&scoped=true"
import script from "./AddressesTab.vue?vue&type=script&lang=js"
export * from "./AddressesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffaf7dc",
  null
  
)

export default component.exports